module.exports = __webpack_public_path__ + "img/clint1.ee27426b.png";